/**
 * Main JavaScript file
 */

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

import LocomotiveScroll from 'locomotive-scroll';
window.LocomotiveScroll = LocomotiveScroll;

import Headroom from 'headroom.js';
window.Headroom = Headroom;

import Viewer from 'viewerjs';
window.Viewer = Viewer;

import './popup.js';
import './team-popup.js';
import './video-trigger.js';
import './cf7-enhance.js';

document.addEventListener('DOMContentLoaded', function() {
    // console.log('WS Theme loaded'); 

    // Theme toggle with persistence (checkbox-driven)
    (function(){
        try {
            var root = document.documentElement;
            var input = document.querySelector('.theme-switch__input');
            var overlay = document.querySelector('.theme-overlay');
            if (!input) return;

            function getTheme(){
                try {
                    var stored = localStorage.getItem('ws-theme');
                    if (stored === 'light' || stored === 'dark') return stored;
                } catch (e) {}
                return root.getAttribute('data-theme') || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
            }

            function setTheme(theme){
                var next = theme === 'light' ? 'light' : 'dark';
                root.setAttribute('data-theme', next);
                try { localStorage.setItem('ws-theme', next); } catch (e) {}
                input.checked = (next === 'light');
            }

            // Init
            setTheme(getTheme());

            input.addEventListener('change', function(){
                var isLight = !!this.checked;

                // Enter: slide from bottom to cover
                document.body.classList.remove('theme-overlay--leave');
                document.body.classList.add('theme-overlay--enter');

                // When covered, swap theme, wait 0.3s, then slide up to exit
                setTimeout(function(){
                    setTheme(isLight ? 'light' : 'dark');
                    setTimeout(function(){
                        document.body.classList.remove('theme-overlay--enter');
                        document.body.classList.add('theme-overlay--leave');

                        setTimeout(function(){
                            document.body.classList.remove('theme-overlay--leave');
                            // Reset overlay position without animating back down
                            try {
                                if (overlay) {
                                    overlay.style.transition = 'none';
                                    overlay.style.transform = 'translateY(100%)';
                                    // Force reflow
                                    void overlay.offsetHeight;
                                    overlay.style.transition = '';
                                    overlay.style.transform = '';
                                }
                            } catch (e) {}
                        }, 320); // match transition
                    }, 300);
                }, 320); // time to enter
            });
        } catch (e) {}
    })();

    // Global throttled Locomotive update helper
    (function(){
        try {
            var scheduled = false;
            function locoUpdate(){
                if (scheduled) return;
                scheduled = true;
                requestAnimationFrame(function(){
                    scheduled = false;
                    try {
                        if (window.wsScroll && typeof window.wsScroll.update === 'function') {
                            window.wsScroll.update();
                        }
                    } catch (e) {}
                });
            }
            window.wsLocoUpdate = locoUpdate;
            // Optional: listen to custom mutation events from widgets
            window.addEventListener('ws:swiper-mutated', locoUpdate);
        } catch (e) {}
    })();
    // Offcanvas burger menu
    (function(){
        var burger = document.querySelector('.burger');
        var offcanvas = document.getElementById('offcanvas-menu');
        var menuToggle = document.querySelector('.site-header__menu-toggle');
        var burgerLabel = document.querySelector('.burger__label');
        if (!burger || !offcanvas) return;

        function openMenu(){
            offcanvas.setAttribute('aria-hidden', 'false');
            burger.classList.add('is-active');
            burger.setAttribute('aria-expanded', 'true');
            if (menuToggle) {
                menuToggle.classList.add('is-open');
            }
            // Lock scrolling (Locomotive + native fallback)
            try {
                document.documentElement.classList.add('offcanvas-open');
            } catch (e) {}
            try {
                if (window.wsScroll && typeof window.wsScroll.stop === 'function') {
                    window.wsScroll.stop();
                }
            } catch (e) {}
            // For native scrolling (mobile or when smooth is disabled), fix body and preserve scroll position
            try {
                var isSmooth = !!(window.wsScroll && window.wsScroll.options && window.wsScroll.options.smooth);
                if (!isSmooth) {
                    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
                    document.documentElement.setAttribute('data-offcanvas-prev-scroll', String(y));
                    document.body.classList.add('offcanvas-open');
                    document.body.style.top = (-y) + 'px';
                    document.body.style.width = '100%';
                    document.body.style.position = 'fixed';
                }
            } catch (e) {}
            // Initialize 3D model in offcanvas on first open
            try {
                if (typeof window.wsInitModel3DSectionIn === 'function') {
                    window.wsInitModel3DSectionIn(offcanvas);
                }
            } catch (e) {}
        }
        function closeMenu(){
            offcanvas.setAttribute('aria-hidden', 'true');
            burger.classList.remove('is-active');
            burger.setAttribute('aria-expanded', 'false');
            if (menuToggle) {
                menuToggle.classList.remove('is-open');
            }
            // Unlock scrolling (Locomotive + native fallback)
            try {
                document.documentElement.classList.remove('offcanvas-open');
            } catch (e) {}
            // Restore native scroll position if we fixed the body
            try {
                var isSmooth = !!(window.wsScroll && window.wsScroll.options && window.wsScroll.options.smooth);
                if (!isSmooth) {
                    var prev = parseInt(document.documentElement.getAttribute('data-offcanvas-prev-scroll') || '0', 10) || 0;
                    document.body.classList.remove('offcanvas-open');
                    document.body.style.top = '';
                    document.body.style.width = '';
                    document.body.style.position = '';
                    document.documentElement.removeAttribute('data-offcanvas-prev-scroll');
                    window.scrollTo(0, prev);
                }
            } catch (e) {}
            try {
                if (window.wsScroll && typeof window.wsScroll.start === 'function') {
                    window.wsScroll.start();
                    if (typeof window.wsScroll.update === 'function') {
                        // Give layout a tick to settle then update
                        setTimeout(function(){
                            try { window.wsScroll.update(); } catch (e) {}
                        }, 50);
                    }
                }
            } catch (e) {}
        }
        function toggleMenu(){
            var hidden = offcanvas.getAttribute('aria-hidden') !== 'false';
            hidden ? openMenu() : closeMenu();
        }

        if (menuToggle) {
            menuToggle.addEventListener('click', function(e){
                e.preventDefault();
                toggleMenu();
            });
        } else {
            burger.addEventListener('click', toggleMenu);
            if (burgerLabel) {
                burgerLabel.addEventListener('click', function(e){
                    e.preventDefault();
                    toggleMenu();
                });
            }
        }

        offcanvas.addEventListener('click', function(e){
            var target = e.target;
            if (!target) return;
            if (target.hasAttribute('data-offcanvas-close')) {
                closeMenu();
            }
        });

        document.addEventListener('keydown', function(e){
            if (e.key === 'Escape') closeMenu();
        });
    })();


    // Headroom integration + header scroll bridging for Locomotive
    (function(){
        try {
            var header = document.querySelector('#masthead');
            if (!header) return;

            // When Locomotive is absent, use native Headroom if available
            if (window.Headroom && !window.LocomotiveScroll) {
                var headroom = new window.Headroom(header, {
                    tolerance: { up: 5, down: 0 },
                    offset: 80,
                    classes: {
                        initial: 'headroom',
                        pinned: 'headroom--pinned',
                        unpinned: 'headroom--unpinned',
                        top: 'headroom--top',
                        notTop: 'headroom--not-top',
                        bottom: 'headroom--bottom',
                        notBottom: 'headroom--not-bottom'
                    }
                });
                headroom.init();
                return;
            }

            // When Locomotive is present, emulate Headroom using its scroll events
            var attached = false;
            function attachToScroll(scroll){
                if (!scroll || typeof scroll.on !== 'function' || attached) return;
                attached = true;
                var lastY = 0;
                var ticking = false;
                var offset = 80;
                // Accumulate delta to avoid false triggers from Locomotive's lerp oscillations.
                // A single-frame positive blip during upward scroll won't flip the header.
                var accum = 0;
                var HIDE_THRESHOLD = 80;  // px downward needed to hide
                var SHOW_THRESHOLD = 15;  // px upward needed to show
                header.classList.add('headroom');

                function setState(state){
                    if (state === 'pinned') {
                        header.classList.add('headroom--pinned');
                        header.classList.remove('headroom--unpinned');
                    } else if (state === 'unpinned') {
                        header.classList.add('headroom--unpinned');
                        header.classList.remove('headroom--pinned');
                    }
                }

                function onScroll(data){
                    if (ticking) return;
                    ticking = true;
                    requestAnimationFrame(function(){
                        var y = data && typeof data.scroll === 'object' ? (data.scroll.y || 0) : 0;
                        var delta = y - lastY;

                        // Top/bottom states
                        var atTop = y <= 0;
                        header.classList.toggle('headroom--top', atTop);
                        header.classList.toggle('headroom--not-top', !atTop);

                        if (y < offset) {
                            // Before offset, always pinned
                            setState('pinned');
                            accum = 0;
                        } else {
                            accum += delta;
                            if (accum > HIDE_THRESHOLD) {
                                setState('unpinned');
                                accum = 0;
                            } else if (accum < -SHOW_THRESHOLD) {
                                setState('pinned');
                                accum = 0;
                            }
                        }

                        lastY = y;
                        ticking = false;
                    });
                }

                // Initial state
                setState('pinned');
                scroll.on('scroll', onScroll);
            }

            // Bridge wheel events on the fixed header to Locomotive's container,
            // so scrolling still works when the cursor is over the header.
            var bridgeAttached = false;
            function bridgeHeaderScroll(scroll){
                try {
                    if (bridgeAttached) return;
                    if (!scroll || !scroll.el || !header) return;

                    var el = scroll.el;
                    bridgeAttached = true;

                    var wheelEvents = ['wheel', 'mousewheel', 'DOMMouseScroll'];
                    wheelEvents.forEach(function(evtName){
                        header.addEventListener(evtName, function(e){
                            // Do not interfere when offcanvas/menu has locked scrolling
                            try {
                                if (document.documentElement.classList.contains('offcanvas-open')) return;
                            } catch (err) {}

                            // Only needed when Locomotive's smooth scrolling is active
                            try {
                                var html = document.documentElement;
                                if (!html || !html.classList.contains('has-scroll-smooth')) return;
                            } catch (err2) {}

                            try {
                                var cloned;
                                try {
                                    // Clone the original wheel event as faithfully as possible
                                    cloned = new e.constructor(e.type, e);
                                } catch (ctorErr) {
                                    // Fallback for very old browsers
                                    cloned = new WheelEvent(e.type, {
                                        deltaY: e.deltaY,
                                        deltaX: e.deltaX,
                                        deltaMode: e.deltaMode,
                                        clientX: e.clientX,
                                        clientY: e.clientY,
                                        ctrlKey: e.ctrlKey,
                                        altKey: e.altKey,
                                        shiftKey: e.shiftKey,
                                        metaKey: e.metaKey
                                    });
                                }
                                el.dispatchEvent(cloned);
                            } catch (dispatchErr) {}
                        }, { passive: false });
                    });
                } catch (e) {}
            }

            if (window.wsScroll) {
                attachToScroll(window.wsScroll);
                bridgeHeaderScroll(window.wsScroll);
            }
            window.addEventListener('ws:locomotive-ready', function(e){
                var s = e && e.detail && e.detail.scroll;
                var scroll = s || window.wsScroll;
                attachToScroll(scroll);
                bridgeHeaderScroll(scroll);
            }, { once: true });
        } catch (e) {}
    })();

    // Mobile menu toggle for primary navigation
    // Replaced by offcanvas burger menu

    function initModel3DSection(context) {
        var root = context || document;
        var els = root.querySelectorAll('.js-model3d-section__canvas');
        if (!els || !els.length) return;
        els.forEach(function(el){
            if (!el || el.dataset.model3dReady) return;
            el.dataset.model3dReady = '1';
            // Lazy import to avoid bundling heavy three.js into editor unnecessarily
            import(/* @vite-ignore */ './model3d-section.js').then(function(mod){
                if (mod && typeof mod.initModel3DSection === 'function') {
                    mod.initModel3DSection(el);
                }
            }).catch(function(){});
        });
    }

    try { window.wsInitModel3DSectionIn = initModel3DSection; } catch (e) {}
    // Ensure initialization runs even if the block view script fires earlier
    initModel3DSection(document);

    // Locomotive Scroll init
    (function(){
        try {
            var container = document.querySelector('[data-scroll-container]');
            if (!container || !window.LocomotiveScroll) return;

            var prefersReducedMotion = false;
            try {
                prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            } catch (e) {}
            var isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0));

            // Optionally mark sections to help Locomotive split
            // try {
            //     container.querySelectorAll('section').forEach(function(sec){
            //         if (!sec.hasAttribute('data-scroll-section')) sec.setAttribute('data-scroll-section', '');
            //     });
            // } catch (e) {}

            var useSmooth = !prefersReducedMotion && !isTouch;

            var scroll = new window.LocomotiveScroll({
                el: container,
                smooth: useSmooth,
                lerp: 0.2,
                smartphone: { smooth: false },
                tablet: { smooth: false }
            });

            try { window.wsScroll = scroll; } catch (e) {}
            try {
                window.dispatchEvent(new CustomEvent('ws:locomotive-ready', { detail: { scroll: scroll } }));
            } catch (e) {}

            // Robust updates after layout shifts (lazy images, fonts, dynamic content, BFCache)
            // Debounced update scheduler to avoid "jank" during smooth scrolling
            var wsLocoUpdateTimer = null;
            var wsLocoScrollingRecently = false;
            var wsLocoScrollingTimer = null;

            // Mark "scrolling recently" so we don't update while smooth scrolling is active
            try {
                if (scroll && typeof scroll.on === 'function') {
                    scroll.on('scroll', function(){
                        wsLocoScrollingRecently = true;
                        clearTimeout(wsLocoScrollingTimer);
                        wsLocoScrollingTimer = setTimeout(function(){
                            wsLocoScrollingRecently = false;
                        }, 160);
                    });
                }
            } catch (e) {}

            function runUpdate(){
                try {
                    if (window.wsLocoUpdate && typeof window.wsLocoUpdate === 'function') {
                        window.wsLocoUpdate();
                    } else if (scroll && typeof scroll.update === 'function') {
                        scroll.update();
                    }
                } catch (e) {}
            }

            function scheduleUpdate(delay){
                var d = (typeof delay === 'number' && isFinite(delay) && delay >= 0) ? delay : 120;
                // If user is actively scrolling, postpone a bit to avoid visible "snap"
                if (wsLocoScrollingRecently) d = Math.max(d, 220);

                clearTimeout(wsLocoUpdateTimer);
                wsLocoUpdateTimer = setTimeout(function(){
                    try {
                        if (typeof window.requestIdleCallback === 'function') {
                            window.requestIdleCallback(function(){ runUpdate(); }, { timeout: 350 });
                        } else {
                            runUpdate();
                        }
                    } catch (e) {
                        runUpdate();
                    }
                }, d);
            }

            // A couple of "settling" updates help with rare first-measure glitches (but keep them gentle)
            scheduleUpdate(120);
            scheduleUpdate(600);

            // Fonts can shift layout after first paint
            try {
                if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
                    document.fonts.ready.then(function(){ scheduleUpdate(120); });
                }
            } catch (e) {}

            // Capture lazy-loaded media inside the scroll container
            // (native 'load' does not bubble, so we listen in capture phase)
            try {
                document.addEventListener('load', function(e){
                    var t = e && e.target;
                    if (!t || !container.contains(t)) return;
                    var tag = (t.tagName || '').toUpperCase();
                    if (tag === 'IMG' || tag === 'IFRAME' || tag === 'VIDEO') {
                        scheduleUpdate(140);
                    }
                }, true);
                document.addEventListener('error', function(e){
                    // Even failed media loads can change layout (fallback UI), so update once.
                    var t = e && e.target;
                    if (!t || !container.contains(t)) return;
                    var tag = (t.tagName || '').toUpperCase();
                    if (tag === 'IMG' || tag === 'IFRAME' || tag === 'VIDEO') {
                        scheduleUpdate(140);
                    }
                }, true);
            } catch (e) {}

            // BFCache restores can desync measurements
            try {
                window.addEventListener('pageshow', function(e){
                    if (e && e.persisted) scheduleUpdate(200);
                });
            } catch (e) {}

            // Orientation changes often shift heights without a classic resize cadence
            try {
                window.addEventListener('orientationchange', function(){ scheduleUpdate(280); });
            } catch (e) {}

            // If elements animate their height (accordion etc.), update after it finishes
            try {
                container.addEventListener('transitionend', function(e){
                    var prop = (e && e.propertyName) ? String(e.propertyName) : '';
                    if (prop && (prop.indexOf('height') !== -1 || prop.indexOf('width') !== -1 || prop.indexOf('padding') !== -1 || prop.indexOf('margin') !== -1)) {
                        scheduleUpdate(160);
                    }
                }, true);
            } catch (e) {}

            // Update after images/fonts load
            window.addEventListener('load', function(){
                try { scroll.update(); } catch (e) {}
                // One more tick catches late lazy-loaded above-the-fold media
                scheduleUpdate(260);
            });

            var resizeTimer;
            window.addEventListener('resize', function(){
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function(){
                    try { scroll.update(); } catch (e) {}
                }, 200);
            });
        } catch (e) {}
    })();

    // Generic counters with zero-padding
    (function(){
        function initCounters(context){
            var root = context || document;
            var els = root.querySelectorAll('[data-ws-counter]');
            if (!els || !els.length) return;

				// Fallback observer (when data-scroll is not used)
				var ioObserver = new IntersectionObserver(function(entries){
					entries.forEach(function(entry){
						if (!entry.isIntersecting) return;
						var el = entry.target;
						if (el.dataset.counterReady) return;
						el.dataset.counterReady = '1';
						animate(el);
						ioObserver.unobserve(el);
					});
				}, { threshold: 0.6 });

				function startWhenTrulyVisible(wrapperEl, valueEl){
					if (!wrapperEl || wrapperEl.dataset.counterReady) return;
					var thrAttr = parseFloat(wrapperEl.getAttribute('data-counter-threshold') || (valueEl && valueEl.getAttribute('data-counter-threshold')) || '0.6');
					var threshold = (isFinite(thrAttr) && thrAttr > 0 && thrAttr < 1) ? thrAttr : 0.6;
					var started = false;
					var ticking = false;

					function byRect(){
						try {
							var rect = valueEl.getBoundingClientRect();
							var vh = window.innerHeight || document.documentElement.clientHeight;
							var visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
							var ratio = rect.height > 0 ? Math.max(0, visible) / rect.height : 0;
							if (ratio >= threshold) {
								started = true;
								wrapperEl.dataset.counterReady = '1';
								setTimeout(function(){ animate(wrapperEl); }, 120);
							}
						} catch (e) {}
					}

					byRect();
					if (started) return;

					// Prefer Locomotive scroll events when available
					if (window.wsScroll && typeof window.wsScroll.on === 'function') {
						var scroll = window.wsScroll;
						var onScroll = function(){
							if (started) return;
							if (ticking) return;
							ticking = true;
							requestAnimationFrame(function(){
								ticking = false;
								if (started) return;
								byRect();
								if (started && typeof scroll.off === 'function') {
									try { scroll.off('scroll', onScroll); } catch (e) {}
								}
							});
						};
						scroll.on('scroll', onScroll);
						// Also recheck shortly in case first byRect() ran before transform settled
						setTimeout(function(){ if (!started) byRect(); }, 100);
					} else {
						// Fallback to native IntersectionObserver when Locomotive is absent
						try {
							var obs = new IntersectionObserver(function(entries){
								entries.forEach(function(entry){
									if (!entry.isIntersecting) return;
									var ratio = typeof entry.intersectionRatio === 'number' ? entry.intersectionRatio : 0;
									if (ratio >= threshold && !started) {
										started = true;
										try { obs.disconnect(); } catch (e) {}
										wrapperEl.dataset.counterReady = '1';
										setTimeout(function(){ animate(wrapperEl); }, 120);
									}
								});
							}, { threshold: [0, threshold] });
							obs.observe(valueEl);
						} catch (e) {
							ioObserver.observe(wrapperEl);
						}
					}
				}

				els.forEach(function(el){
					var valueEl = el.querySelector('.ws-counter__value') || el;
					var usesScroll = valueEl && valueEl.hasAttribute('data-scroll');
					if (usesScroll) {
						// Start immediately if already in view
						if (valueEl.classList.contains('is-inview')) {
							startWhenTrulyVisible(el, valueEl);
						} else {
							// Watch for class changes and fire once when is-inview appears
							try {
								var mo = new MutationObserver(function(){
									if (valueEl.classList.contains('is-inview')) {
										try { mo.disconnect(); } catch (e) {}
										startWhenTrulyVisible(el, valueEl);
									}
								});
								mo.observe(valueEl, { attributes: true, attributeFilter: ['class'] });
							} catch (e) {}
						}
					} else {
						// No data-scroll: fallback to intersection observer on wrapper
						ioObserver.observe(el);
					}
				});

            function animate(el){
                var target = parseInt(el.getAttribute('data-counter-target') || '0', 10);
                if (!isFinite(target) || target < 0) target = 0;
                var digitsAttr = parseInt(el.getAttribute('data-counter-digits') || '', 10);
                var digits = (isFinite(digitsAttr) && digitsAttr > 0) ? digitsAttr : (String(Math.abs(target)).length || 1);
                var valueEl = el.querySelector('.ws-counter__value') || el;

					var duration = 2000; // a bit slower
                var start = performance.now();
					var startVal = Math.max(0, target - 10); // animate last 10 numbers

                function tick(now){
                    var t = Math.min(1, (now - start) / duration);
                    var eased = 1 - Math.pow(1 - t, 3);
                    var current = Math.round(startVal + (target - startVal) * eased);
                    var txt = String(current).padStart(digits, '0');
                    valueEl.textContent = txt;
                    if (t < 1) requestAnimationFrame(tick);
                }
                requestAnimationFrame(tick);
            }
        }

        try { window.wsInitCountersIn = initCounters; } catch (e) {}
        initCounters(document);

        if (window.acf && typeof window.acf.addAction === 'function') {
            try {
                window.acf.addAction('render_block_preview', function($el){
                    var node = $el && $el[0] ? $el[0] : document;
                    initCounters(node);
                });
            } catch (e) {}
        }
    })();

    // Contact widget toggling
    (function(){
        try {
            var root = document.querySelector('.contact-widget');
            if (!root) return;
            var btn = root.querySelector('.contact-widget__button');
            var closeBtn = root.querySelector('.contact-widget__close');

            function openWidget(){
                root.classList.add('is-open');
                try { if (btn) btn.setAttribute('aria-expanded', 'true'); } catch (e) {}
            }
            function closeWidget(){
                root.classList.remove('is-open');
                try { if (btn) btn.setAttribute('aria-expanded', 'false'); } catch (e) {}
            }
            function toggleWidget(){
                if (root.classList.contains('is-open')) {
                    closeWidget();
                } else {
                    openWidget();
                }
            }

            if (btn) btn.addEventListener('click', function(e){
                e.preventDefault();
                toggleWidget();
            });
            if (closeBtn) closeBtn.addEventListener('click', function(e){
                e.preventDefault();
                closeWidget();
            });

            document.addEventListener('keydown', function(e){
                if (e.key === 'Escape') closeWidget();
            });
            document.addEventListener('click', function(e){
                var target = e.target;
                if (!target) return;
                if (!root.contains(target)) {
                    closeWidget();
                }
            });
        } catch (e) {}
    })();

    // Lists – expandable list columns
    (function(){
        try {
            var cols = document.querySelectorAll('.lists__col--list--collapsible');
            if (!cols || !cols.length) return;

            cols.forEach(function(col){
                var toggle = col.querySelector('.lists__toggle');
                if (!toggle) return;

                toggle.addEventListener('click', function(){
                    var isCollapsed = col.classList.contains('lists__col--list--collapsed');

                    if (isCollapsed) {
                        col.classList.remove('lists__col--list--collapsed');
                        col.classList.add('lists__col--list--expanded');
                        toggle.setAttribute('aria-expanded', 'true');
                    } else {
                        col.classList.add('lists__col--list--collapsed');
                        col.classList.remove('lists__col--list--expanded');
                        toggle.setAttribute('aria-expanded', 'false');
                    }

                    try {
                        if (window.wsLocoUpdate && typeof window.wsLocoUpdate === 'function') {
                            window.wsLocoUpdate();
                        }
                    } catch (e) {}
                });
            });
        } catch (e) {}
    })();
}); 